import { render, staticRenderFns } from "./ForgetPhone.vue?vue&type=template&id=a4ad8f88&scoped=true&"
import script from "./ForgetPhone.vue?vue&type=script&lang=js&"
export * from "./ForgetPhone.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPhone.vue?vue&type=style&index=0&id=a4ad8f88&prod&lang=css&"
import style1 from "./ForgetPhone.vue?vue&type=style&index=1&id=a4ad8f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad8f88",
  null
  
)

export default component.exports